import { Component, forwardRef } from '@angular/core';
import { StartAction } from '../../../../Model/Dto/StartAction';
import { UserActionByListComponent } from '../userAction-byList/userAction-byList.component';
import { SearchByListParameter } from '../../../../Model/Dto/SearchByListParameter';
import { TranslateService } from '@ngx-translate/core';
import { CatalogService } from 'app/Services/CatalogManagement/catalog.service';
import { MacroService } from 'app/Services/CatalogManagement/macro.service';
import { JobService } from 'app/Services/job.service';
import { LoginService } from 'app/Services/login.service';
import { UserActionBaseComponent } from '../userAction-base.component';
import DataSource from 'devextreme/data/data_source';
import { ExportFilterService } from '../../../../Services/exportFilter.service';
import { SystemService } from '../../../../Services/system.service';

@Component({
  selector: 'userAction-searchByList',
  templateUrl: 'userAction-searchByList.component.html',
  providers: [
    { provide: UserActionBaseComponent, useExisting: forwardRef(() => UserActionSearchByListComponent) }
  ]
})
export class UserActionSearchByListComponent extends UserActionByListComponent {
  constructor(
    public loginService: LoginService,
    public macroService: MacroService,
    public jobService: JobService,
    public translate: TranslateService,
    public catalogService: CatalogService,
    public exportFilterService: ExportFilterService,
    public systemService: SystemService
  ) {
    super(loginService, macroService);
    this.handlePropertyChange = this.handlePropertyChange.bind(this);
    this.canStartMacro = this.canStartMacro.bind(this);
    this.getSearchValueDisplayExpr = this.getSearchValueDisplayExpr.bind(this);
    this.searchValue = this.searchValues[0];

    this.getNoDataText = this.getNoDataText.bind(this);
    this.loadingVisible = true;
    this.exportFilterService
      .getManufacturerFilters(this.catalogService.selectedCatalogId, this.loginService.currentUser.customerId)
      .toPromise()
      .then((filter: string[]) => {
        this.manufacturerFilters = filter.filter((x) => x != null);
        this.manufacturerDataSource = new DataSource({
          store: this.manufacturerFilters,
          paginate: true,
          pageSize: 10
        });
      })
      .finally(() => {
        this.loadingVisible = false;
      });
  }

  searchValues = ['SUPPLIER_PID', 'SUPPLIER_ALT_PID', 'INTERNATIONAL_PID', 'MANUFACTURER_NAME', 'PID', 'MANUFACTURER_PID'];
  searchValue = '';

  loadingVisible = false;
  manufacturerFilters = [];
  selectedManufacturer: string[] = [];
  manufacturerDataSource: DataSource;

  getNoDataText() {
    if (this.loadingVisible) {
      return this.translate.instant('Daten werden geladen');
    } else {
      return this.translate.instant('keine Daten gefunden');
    }
  }

  handlePropertyChange(event) {
    this.searchValue = event.item.value;
  }

  createParameterStringAsJsonString(): string {
    this.inputList = this.formatListIgnoreSpace(this.inputList);
    let values = this.inputList;
    if (this.searchValue == 'MANUFACTURER_NAME')
      values = this.selectedManufacturer.join('\n');
    return JSON.stringify(new SearchByListParameter(this.searchValue, values));
  }

  public async canStartMacro(): Promise<boolean> {
    let values = this.inputList;
    if (this.searchValue == 'MANUFACTURER_NAME')
      values = this.selectedManufacturer.join('\n');
    if (values == "") {
      this.systemService.notifyInfo(this.translate.instant('Bitte mindestens einen Wert, nach dem gesucht werden soll, eingeben'));
      return false;
    }
    return true;
  }

  getSearchValueDisplayExpr(item) {
    if (!item) {
      return '';
    }

    return this.translate.instant(item);
  }

  parseParameter(parameter: string) {
    if(!parameter)
      return;
    try {
      const parsed : SearchByListParameter= JSON.parse(parameter);
      this.searchValue = parsed.key;
      this.inputList = parsed.list;
    } catch (error) {
      console.error('Invalid JSON string provided:', error);
    }
  }
}
